import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { schoolDetail, updateSchoolDetail } from '@/services/apiServices'

export const useSchoolStore = defineStore('school', () => {
    const details = ref({
      // id: null,
    name: "",
  });

  const error = ref(null)
  const isLoading = ref(false)

  // Fetch school details
  const fetchSchoolDetails = async () => {
    isLoading.value = true
    error.value = null
    try {
      const data = await schoolDetail()
      details.value = data
    } catch (err) {
      error.value = err.response?.data?.message || "Failed to load school details"
    } finally {
      isLoading.value = false
    }
  }

  // Update school details
  const updateSchoolDetails = async (formData) => {
    isLoading.value = true
    error.value = null
    try {
      const data = await updateSchoolDetail(formData)
      details.value = { ...details.value, ...data }

      // Update preview URLs if file was uploaded
      if (formData.get('logo')) {
        details.value.logo = URL.createObjectURL(formData.get('logo'))
      }
      if (formData.get('logo_blur')) {
        details.value.logo_blur = URL.createObjectURL(formData.get('logo_blur'))
      }
      if (formData.get('principal_sign')) {
        details.value.principal_sign = URL.createObjectURL(formData.get('principal_sign'))
      }

      return true
    } catch (err) {
      error.value = err.response?.data?.message || "Failed to save changes"
      return false
    } finally {
      isLoading.value = false
    }
  }

  // Getter
  const isLongName = computed(() => details.value.name?.length > 20 || false)

  return {
    details,
    error,
    isLoading,
    fetchSchoolDetails,
    updateSchoolDetails,
    isLongName
  }
})
